import styled from 'styled-components';
import {
  FlexLayout,
  ListHeader as ListHeaderComponent,
} from '@gv/triage-components';

export const ListHeaderContainer = styled(FlexLayout)`
  gap: 16px;
  margin: 0 16px 0 16px;
  flex-direction: column;

  > :last-child {
    margin-bottom: 16px;
  }
`;

export const ListHeader = styled(ListHeaderComponent)`
  > :last-child {
    text-align: center;
  }
`;
